<template>
  <div class="dialog" v-if="visible">
    <div class="dialog__masker"></div>
     <transition name="dialog">
      <div class="dialog__box" :class="{ 'no-bg': noBg }" :style="frameStyle">
        <!-- title -->
        <p class="dialog-title absolute text-center" v-if="title">{{ title }}</p>
        <!-- 关闭按钮 -->
        <img
          v-if="showClose"
          class="dialog-close cursor-pointer"
          src="@/render/assets/images/close.png"
          alt="close"
          @click="onClose"
        />
        <!-- 主体内容 -->
        <slot />
      </div>
     </transition>
  </div>
  
</template>

<script>
export default {
  name: 'Dialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    showClose: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
    size: {
      type: Object, // { width: string, height: string }
    },
    noBg: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  components: {},
  computed: {
    frameStyle() {
      if (!this.size) return {}
      return { width: this.size.width, height: this.size.height }
    },
  },
  watch: {
    visible(flg) {
      if (!flg) this.onClose()
    },
  },
  async mounted() {},
  methods: {
    onClose() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.dialog {
  // position: fixed;
  // top: 50%;
  // left: 50%;
  // transform: translate(-50%, -50%);
  // width: val(848);
  // min-height: val(566);
  // color: var(--dialog-color);
  // font-size: val(26);
  // padding: val(80) val(40) val(40);
  // background-size: 100% 100%;
  // z-index: 999;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  &__masker {
    position: absolute;
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.5;
  }
  &__box {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: val(848);
    min-height: val(566);
    color: var(--dialog-color);
    font-size: val(26);
    padding: val(80) val(40) val(40);
    background-size: 100% 100%;
  }
  &.no-bg {
    background: none;
  }
  &-close {
    position: absolute;
    top: val(8);
    right: val(-20);
    width: val(33);
    height: val(33);
  }
  &-title {
    width: 100%;
    left: 0px;
    top: val(12);
    color: var(--dialog-title-color);
    font-size: val(26);
    text-shadow: 0px 2px 0px rgba(0, 0, 0, 0.46);
  }
}

.dialog-enter-active,
.dialog-leave-active {
  transition: all 0.3s;
}
.dialog-enter, .dialog-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translate(-50%, -50%) scale(0.5);
  opacity: 0;
}
</style>
